<ndt-locations-register-view
   [locationPrivileges]="locationPrivileges$ | async"
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   (create)="onCreate()"
   [name]="entityName"
   [columns]="columns"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
></ndt-locations-register-view>
